import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";
import Select from "react-select";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

const AdminCompanyFilter = ({ onSearch }) => {
  const adminToken = localStorage.getItem("adminToken");
  const [industriesOption, setIndustriesOption] = useState([]);
  const [companySizeOption, setCompanySizeOption] = useState([]);
  const [companyRevenueOption, setCompanyRevenueOption] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [selectedCompanyNames, setSelectedCompanyNames] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [selectedRevenue, setSelectedRevenue] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filters, setFilters] = useState({
    companyName: "",
    companyUrl: "",
    ceo: "",
    status: "",
    headquarter: "",
    start_date: "",
    end_date: "",
    companySize: "",
    companyRevenue: "",
    industry: "",
  });
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const ymdToDate = (s) => {
    if (!s) return null;
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, (m || 1) - 1, d || 1);
  };
  const [range, setRange] = useState([
    {
      startDate: filters.start_date ? ymdToDate(filters.start_date) : new Date(),
      endDate: filters.end_date ? ymdToDate(filters.end_date) : new Date(),
      key: "selection",
    },
  ]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection || {};
    const sd = startDate ? new Date(startDate) : null;
    const ed = endDate ? new Date(endDate) : sd; // single-date: end = start

    setRange([ranges.selection]);

    const toYmd = (d) => {
      if (!d) return "";
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    setFilters((prev) => ({
      ...prev,
      start_date: toYmd(sd),
      end_date: toYmd(ed),
    }));
  };

  const statusOptions = [
    { value: "1", label: "Verified" },
    { value: "2", label: "Pending for verification" },
  ];

  useEffect(() => {
    getCompanyNames();
    getEmployees();
    getRevenue();
    getIndustiry();
  }, []);

  const getCompanyNames = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/company/fetch-companyNames`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status == 200) {
        const apiData = response.data.data.flat();
        // console.log("company names api data for company name", apiData);
        const options = apiData.map((item) => ({
          value: item.company_name, // used internally
          label: item.company_name, // shown in dropdown
        }));
        setCompanyName(options);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };
  const getEmployees = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/employee`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status == 200) {
        const apiData = response.data.employees.flat();
        // console.log("company names api data for .................. name", apiData);
        const options = apiData.map((item) => ({
          value: item.answer, // used internally
          label: item.answer, // shown in dropdown
        }));
        setEmployees(options);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };
  const getRevenue = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/revenue`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status == 200) {
        const apiData = response.data.revenue;
        // console.log("company names api data for .................. name", apiData);
        const options = apiData.map((item) => ({
          value: item.answer, // used internally
          label: item.answer, // shown in dropdown
        }));
        setRevenue(options);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  const getIndustiry = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/industries`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status == 200) {
        const apiData = response.data.data;
        const options = apiData.map((item) => ({
          value: item.answer, // used internally
          label: item.answer, // shown in dropdown
        }));
        setIndustry(options);

        // console.log(response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  useEffect(() => {
    const fetchFilterOptions = async () => {
      if (!adminToken) return;

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminToken}`,
      };

      try {
        const [industryRes, sizeRes, revenueRes] = await Promise.all([
          axios.post(`${process.env.REACT_APP_API_URL}/api/survey/industries`, {}, { headers }),
          axios.post(`${process.env.REACT_APP_API_URL}/api/survey/Company-Size`, {}, { headers }),
          axios.post(`${process.env.REACT_APP_API_URL}/api/survey/Company-Revenue`, {}, { headers }),
        ]);

        setIndustriesOption(industryRes.data.data.map((item) => item.answer.trim()));
        setCompanySizeOption(sizeRes.data.data.map((item) => item.answer));
        setCompanyRevenueOption(revenueRes.data.data.map((item) => item.answer));
      } catch (error) {
        console.error("Error fetching filter options:", error);
      }
    };

    fetchFilterOptions();
  }, [adminToken]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(filters);
  };

  // Close date picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <>
      <form onSubmit={handleSearch}>
        <div className="my-5 filter-box">
          <div
            className="p-4 rounded"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #dee2e6",
            }}
          >
            <div className="row  align-items-center">
              {/* Row 1 */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <Select
                    isMulti
                    options={companyName} // mapped data
                    value={selectedCompanyNames} // selected values
                    onChange={(selected) => setSelectedCompanyNames(selected)}
                    placeholder="Select Company Name"
                    classNamePrefix="custom-select"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <input
                    type="text"
                    className="form-control filter-input"
                    placeholder="Company URL"
                    name="companyUrl"
                    value={filters.companyUrl}
                    onChange={handleFilterChange}
                  />
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <input type="text" className="form-control filter-input" placeholder="CEO" name="ceo" value={filters.ceo} onChange={handleFilterChange} />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <Select
                    options={statusOptions}
                    value={selectedStatus}
                    onChange={(selected) => setSelectedStatus(selected)}
                    placeholder="Select Status"
                    isClearable
                    classNamePrefix="custom-select"
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <input
                    type="text"
                    className="form-control filter-input"
                    placeholder="Headquarter"
                    name="headquarter"
                    value={filters.headquarter}
                    onChange={handleFilterChange}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6" ref={wrapperRef}>
                <div className="position-relative">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control filter-input"
                      placeholder="Added Date Range"
                      style={{ paddingRight: "2.5rem", cursor: "pointer" }}
                      readOnly
                      onClick={() => setIsOpen(!isOpen)}
                      value={
                        filters.start_date && filters.end_date
                          ? `${new Date(filters.start_date + "T00:00:00").toLocaleDateString("en-IN")} - ${new Date(filters.end_date + "T00:00:00").toLocaleDateString("en-IN")}`
                          : ""
                      }
                    />
                  </div>

                  <span
                    role="button"
                    aria-label="Open date range"
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen(!isOpen)}
                    className="position-absolute"
                    style={{
                      top: "18px",
                      right: "12px",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      cursor: "pointer",
                    }}
                  >
                    {/* keep your icon */}
                    <FaCalendarAlt />
                  </span>

                  {isOpen && (
                    <div
                      className="bg-white border rounded shadow"
                      style={{
                        position: "absolute",
                        zIndex: 1050, // above most UI
                        top: "110%",
                        right: 0,
                      }}
                    >
                      <DateRange
                        onChange={handleSelect}
                        moveRangeOnFirstSelection={false}
                        ranges={range}
                        months={1}
                        direction="horizontal"
                        editableDateInputs
                        className="rdr-no-weekdays"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <Select
                    isMulti
                    options={employees} // mapped data
                    value={selectedEmployees} // selected values
                    onChange={(selected) => setSelectedEmployees(selected)}
                    placeholder="Select Employees"
                    classNamePrefix="custom-select"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <Select
                    isMulti
                    options={revenue} // mapped data
                    value={selectedRevenue} // selected values
                    onChange={(selected) => setSelectedRevenue(selected)}
                    placeholder="Select Revenue"
                    classNamePrefix="custom-select"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div class="form-group">
                  <Select
                    isMulti
                    options={industry} // mapped data
                    value={selectedIndustry} // selected values
                    onChange={(selected) => setSelectedIndustry(selected)}
                    placeholder="Select Industry"
                    classNamePrefix="custom-select"
                    closeMenuOnSelect={false}
                  />
                </div>
              </div>
              <div className="col-lg-2 col-md-3  col-sm-6">
                <div class="form-group">
                  <button type="submit" className="btn filter-search">
                    <FaSearch className="me-2" /> Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AdminCompanyFilter;
